import React, {useRef, useState} from 'react'
import emailjs from '@emailjs/browser';
import './form.css'
import { RFQContainer, RFQWrapper, RFQHeading, RFQThanksWrapper, RFQThanksHead, FormInput, FormTextarea, ButtonDiv } from './rfqElements'

const RFQSection = () => {
	const form = useRef()
	const [isSubmitted, setIsSubmitted] = useState(false);

	const sendEmail = (e) => {
	    e.preventDefault();

	    emailjs.sendForm('service_dhecmcp', 'template_bg28ysy', form.current, 'fDlMrsqLFZSi6gIDB')
	      .then((result) => {
	          console.log(result.text);
	      }, (error) => {
	          console.log(error.text);
	      });
	      e.target.reset();
		  setIsSubmitted(true);
	  };

	return (
		<>
			<RFQContainer id="rfq">
				<RFQWrapper>
					<RFQHeading>Request For Quote</RFQHeading>
						{isSubmitted ? (
							<RFQThanksWrapper>
								<RFQThanksHead>Thank you for your RFQ submission!</RFQThanksHead>
							</RFQThanksWrapper>
						) : (
							<form ref={form} onSubmit={sendEmail}>
								<FormInput>
									<input type="text" placeholder="First Name*" name="firstName" required/>
								</FormInput>
								<FormInput>
									<input type="text" placeholder="Last Name*" name="lastName" required />
								</FormInput>
								<FormInput>
									<input type="email" placeholder="Email*" name="email" required />
								</FormInput>
								<FormInput>
									<input type="text" placeholder="Phone Number*" name="phone" required />
								</FormInput>
								<FormInput>
									<input type="text" placeholder="Company*" name="company" required/>
								</FormInput>
								<FormInput>
									<input type="text" placeholder="Quantity of Links to Quote*" name="qty" required/>
								</FormInput>
								<FormTextarea>
									<textarea name="message" placeholder="Message*"></textarea>
								</FormTextarea>
								<ButtonDiv>
									<input class="button" type="submit" value="Submit" />
								</ButtonDiv>
							</form>
						)}
				</RFQWrapper>
			</RFQContainer>
		</>
	)
}

export default RFQSection